import { useNavigate } from 'react-router-dom'
import { Container, Stack, Title, Text, Paper, Group, Button, Loader, Badge, Center } from '@mantine/core'
import { IconUsers, IconPlus, IconArrowLeft, IconUserStar } from '@tabler/icons-react'
import { useTeams } from '../hooks/useTeam'

export default function Teams() {
  const navigate = useNavigate()
  const { data: teams, isLoading, error } = useTeams()

  return (
    <Container size="md" py="xl">
      <Stack gap="lg">
        <Group justify="space-between" align="center">
          <Group gap="sm">
            <Button
              variant="subtle"
              color="gray"
              size="sm"
              leftSection={<IconArrowLeft size={16} />}
              onClick={() => navigate('/profile')}
            >
              Profile
            </Button>
          </Group>
          <Button
            leftSection={<IconPlus size={16} />}
            onClick={() => navigate('/teams/new')}
          >
            Create Team
          </Button>
        </Group>

        <Title order={2} ff="Orbitron, sans-serif" c="cyan.4">
          My Teams
        </Title>

        {isLoading && (
          <Center py="xl">
            <Loader color="cyan" />
          </Center>
        )}

        {error && (
          <Paper p="lg" className="glass">
            <Text c="red.4" size="sm">
              Could not load teams. {error.response?.data?.error || error.message}
            </Text>
          </Paper>
        )}

        {!isLoading && !error && (!teams || teams.length === 0) && (
          <Paper p="xl" className="glass">
            <Stack gap="sm" align="center">
              <IconUsers size={40} color="var(--mantine-color-cyan-4)" />
              <Text c="dimmed" ta="center">
                You're not on any teams yet. Create one or join via an invite link.
              </Text>
            </Stack>
          </Paper>
        )}

        {teams?.map((team) => (
          <Paper
            key={team.id}
            p="lg"
            className="glass"
            style={{ cursor: 'pointer', borderColor: 'rgba(0, 229, 255, 0.15)' }}
            onClick={() => navigate(`/teams/${team.id}`)}
          >
            <Group justify="space-between" wrap="nowrap" align="flex-start">
              <Stack gap={4} style={{ flex: 1 }}>
                <Group gap="sm">
                  <Text fw={600} ff="Orbitron, sans-serif" c="cyan.3">
                    {team.name}
                  </Text>
                  {team.is_facilitator && (
                    <Badge size="xs" color="cyan" leftSection={<IconUserStar size={10} />}>
                      Facilitator
                    </Badge>
                  )}
                </Group>
                <Text size="xs" c="dimmed">
                  {team.member_count != null ? `${team.member_count} member${team.member_count === 1 ? '' : 's'}` : 'Members'}
                  {team.current_story_name ? ` — currently playing ${team.current_story_name}` : ''}
                </Text>
              </Stack>
              <Button variant="light" color="cyan" size="xs">
                Open
              </Button>
            </Group>
          </Paper>
        ))}
      </Stack>
    </Container>
  )
}
